import { apiStartState } from '../../../../utils/reduxOperations';
export function getUserProfileStarted(state, payload) {
    return {
        ...state,
        getUserProfileApi:apiStartState()
    };
}